import * as React from "react";
import Component from "../../AbstractComponent";
import { Link } from "react-router";

export class NotFound extends Component {

  constructor(public props) {
    super(props);
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full full-width has-details-page-header">
          <div className="component-header">
            <h1>404 - {this.trans("title-page-not-found")} <Link to="/">&laquo; {this.trans("title-go-back")}</Link></h1>
          </div>
        </div>
      </div>
    );
  }
}
